// 过滤 title 中的中英文括号及其内容
function filterTitleBrackets(title) {
  if (!title) return title;
  // 过滤英文括号 () 和中文括号 （） 及其内容
  return title
    .replace(/\([^)]*\)/g, "")
    .replace(/（[^）]*）/g, "")
    .trim();
}

// 用于处理动态菜单数据，将其转为 route 形式
export function fnAddDynamicMenuRoutes(menuList = [], routes = []) {
  // 遍历数据并保持原始顺序
  for (let i = 0; i < menuList.length; i++) {
    // 获取路由的基本格式
    let route = getRoute(menuList[i]);

    // 存在子路由，则递归遍历，并返回数据作为 children 保存
    if (menuList[i].children && menuList[i].children.length > 0) {
      // 递归处理子路由数据，并返回，将其作为路由的 children 保存
      route.children = fnAddDynamicMenuRoutes(menuList[i].children);
    }

    // 保存路由，保持原始顺序
    routes.push(route);
  }

  // 返回路由结果
  return routes;
}

// 返回路由的基本格式
function getRoute(item) {
  // 路由基本格式
  let route = {
    // 路由的路径
    path: item.path,
    // 路由名（过滤括号内容）
    name: filterTitleBrackets(item.title),
    // 路由所在组件
    // component: (resolve) => require([`@/layout/Index`], resolve),
    //   component: (resolve) => require([`@/views${item.path}`], resolve),
    component: resolve => require([`@/views${item.path}`], resolve),
    meta: {
      id: item.node_id,
      icon: item.icon,
      requireAuth: true,
      // 保留原始 title（过滤后）用于显示
      title: filterTitleBrackets(item.title)
    },
    // 路由的子路由
    children: []
  };
  // 返回 route
  return route;
}
